document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('bulk-order-form');
    if (!form) return; // Failsafe if script runs when container isn't rendered
    
    const checkboxes = form.querySelectorAll('.item-checkbox');
    const totalDisplay = document.getElementById('cart-total-display');
    const addButton = document.getElementById('add-selected-to-cart');
    const recapContainer = document.getElementById('recap-container');
    const recapList = document.getElementById('recap-list');

    const formatMoney = (cents) => {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const updateCartState = () => {
      let total = 0;
      let hasItems = false;
      
      recapList.innerHTML = '';

      form.querySelectorAll('.item-checkbox:checked').forEach(cb => {
        const price = parseInt(cb.dataset.price);
        total += price;
        hasItems = true;
        
        const li = document.createElement('li');
        li.className = 'recap-item';
        
        const productTitle = cb.dataset.productTitle;
        const variantTitle = cb.dataset.variantTitle;
        
        let variantHtml = '';
        if (variantTitle && variantTitle.toLowerCase() !== 'default title') {
          variantHtml = `<span class="recap-item-variant">(${variantTitle})</span>`;
        }
        
        li.innerHTML = `
          <div>
            <span class="recap-item-title">${productTitle}</span>
            ${variantHtml}
          </div>
          <div style="font-weight: 500;">${formatMoney(price)}</div>
        `;
        
        recapList.appendChild(li);
      });

      totalDisplay.textContent = formatMoney(total);
      
      if (hasItems) {
        recapContainer.classList.remove('hidden');
      } else {
        recapContainer.classList.add('hidden');
      }
    };

    checkboxes.forEach(cb => cb.addEventListener('change', updateCartState));

    // Dynamic logic for handling size changes
    window.updateProductRow = function(selectElement) {
      const row = selectElement.closest('.product-item');
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      
      const newPrice = selectedOption.dataset.price;
      const newVariantId = selectedOption.value;
      const newVariantTitle = selectedOption.dataset.title;
      const isAvailable = selectedOption.dataset.available === 'true';

      const priceDisplay = row.querySelector('.item-price');
      if(priceDisplay) priceDisplay.textContent = formatMoney(newPrice);

      const checkbox = row.querySelector('.item-checkbox');
      const allNotifyLinks = row.querySelectorAll('.variant-notify');

      // First, hide all notify links for this specific product row
      allNotifyLinks.forEach(link => link.style.display = 'none');

      if (isAvailable) {
        // Show checkbox and configure it
        if(checkbox) {
          checkbox.style.display = 'block';
          checkbox.value = newVariantId;
          checkbox.dataset.price = newPrice;
          checkbox.dataset.variantTitle = newVariantTitle;
        }
      } else {
        // Hide and uncheck the checkbox
        if(checkbox) {
          checkbox.style.display = 'none';
          checkbox.checked = false; 
        }
        // Show ONLY the correct direct link for the newly selected variant
        const targetNotify = row.querySelector(`.variant-notify-${newVariantId}`);
        if(targetNotify) {
          targetNotify.style.display = 'inline-flex';
        }
      }
      
      updateCartState(); 
    };

    // Handle Bulk Add to Cart POST request
    addButton.addEventListener('click', () => {
      const items = [];
      
      form.querySelectorAll('.item-checkbox:checked').forEach(cb => {
        items.push({ 
          id: parseInt(cb.value), 
          quantity: 1 
        });
      });

      if (items.length === 0) {
        alert('Please select at least one item to add to your cart.');
        return;
      }

      addButton.disabled = true;
      const originalText = addButton.textContent;
      addButton.textContent = 'Adding to Cart...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(data => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const countElements = document.querySelectorAll('.cart-count, .cart-count-bubble, #CartCount, [data-cart-count], .header__cart-count, .site-header__cart-count, .cart-icon-bubble, .Header__CartCount');
            countElements.forEach(el => {
              el.textContent = cart.item_count;
              el.classList.remove('hidden', 'hide'); 
            });

            window.dispatchEvent(new Event('cart:updated'));
            document.dispatchEvent(new Event('cart:updated'));
            document.dispatchEvent(new Event('cart:build'));
          });

        addButton.textContent = 'Success!';
        
        setTimeout(() => { 
          addButton.disabled = false; 
          addButton.textContent = originalText;
          
          form.querySelectorAll('.item-checkbox:checked').forEach(cb => cb.checked = false);
          updateCartState();
          
        }, 2000);
      })
      .catch(error => {
        console.error('Error adding bulk items:', error);
        alert('There was an error adding these items to your cart.');
        addButton.disabled = false;
        addButton.textContent = originalText;
      });
    });
  });
